import CustomTooltip from '@components/charts/common/CustomTooltip'
import { useTheme } from '@contexts/ThemeContext'
import {
  EventAnalyticsGraphBookingConversion,
  FetchEventAnalyticsGraphParams,
} from '@models/membership/event/EventAnalyticsGraph'
import { fetchAnalyticsGraph } from '@services/AnalyticsGraph'
import { useAppSelector } from '@store/hooks'
import { selectSelectedEvent } from '@store/membership/EventReducer'
import { Card, Empty, Spin } from 'antd'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import {
  Funnel,
  FunnelChart,
  LabelList,
  ResponsiveContainer,
  Tooltip,
} from 'recharts'

const BookingConversion = () => {
  const event = useAppSelector(selectSelectedEvent())
  const { mode } = useTheme()

  const [chartData, setChartData] = useState<
    EventAnalyticsGraphBookingConversion[]
  >([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | undefined>(undefined)

  const fetchData = async () => {
    if (!event) return

    setIsLoading(true)
    setError(undefined)

    const fetchParams: FetchEventAnalyticsGraphParams = {
      entity: 'event',
      entityId: event.id,
      kind: 'booking-conversion',
      startDate: dayjs(event.start).subtract(180, 'days').format('YYYY-MM-DD'),
      endDate: dayjs(event.end).format('YYYY-MM-DD'),
    }

    try {
      const { data } =
        await fetchAnalyticsGraph<EventAnalyticsGraphBookingConversion[]>(
          fetchParams
        )

      setChartData(data || [])

      if (!data) {
        setError('No data available.')
      }
    } catch (error) {
      console.error('Error fetching data:', error)
      setError('An error occurred while fetching data.')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [event])

  const allValuesAreZero = chartData.every(({ value }) => value === 0)

  return (
    <Card
      style={{ alignContent: 'center', textAlign: 'center', minHeight: 450 }}
    >
      {isLoading && <Spin />}
      {(allValuesAreZero || chartData.length === 0 || error) && !isLoading && (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={error} />
      )}
      {!allValuesAreZero && chartData.length > 0 && !isLoading && !error && (
        <ResponsiveContainer width={'100%'} height={380}>
          <FunnelChart>
            <Tooltip
              content={(props) => (
                <CustomTooltip
                  type="funnel"
                  {...props}
                  customLabelFormatter={(payload) => {
                    return payload.label
                  }}
                />
              )}
            />
            <Funnel dataKey="value" data={chartData} isAnimationActive>
              <LabelList
                position="right"
                fill={mode === 'dark' ? 'white' : 'dark'}
                stroke="none"
                dataKey="name"
              />
            </Funnel>
          </FunnelChart>
        </ResponsiveContainer>
      )}
    </Card>
  )
}

export default BookingConversion
